<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Classement des dossiers - Nature
      </h2>
    </div>
  </div>
  <CriteresRechercheNature ref="criteresRechercheNature" @rechercher="rechercher" @fermer="fermer"/>
  <ResultatRechercheNature :natures="natures" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>
import ResultatRechercheNature from "@/components/pilotage/ClassementDeDossier/ResultatRechercheNature.vue";
import CriteresRechercheNature from "@/components/pilotage/ClassementDeDossier/CriteresRechercheNature.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "RechercherNature",
  components: {CriteresRechercheNature, ResultatRechercheNature},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
    isRechercheDataLoading: false,
    natures: [],
    }
  },
  mounted() {
    this.entite = Number(this.$route.params.entite)
    this.genre = Number(this.$route.params.genre)
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Nature");
  },
  methods: {
    rechercher(libelleRecherche) {
      this.natures = [];
      this.isRechercheDataLoading = true;

      this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
        res.data.libelles.forEach((currentEntite) => {
          currentEntite.tableValeur.libelles.forEach((currentGenre) => {
            currentGenre.tableValeur.libelles.forEach((currentNature) => {                
              let currentNatureComplete = currentNature;
              currentNatureComplete.entite = currentEntite.tableValeur.cle
              currentNatureComplete.entiteDescription = currentEntite.tableValeur.description;
              currentNatureComplete.genre = currentGenre.tableValeur.cle
              currentNatureComplete.genreDescription = currentGenre.tableValeur.description;
              this.natures.push(currentNatureComplete)
            })
          })
        })
        this.isRechercheDataLoading = false;
      });
    },
  fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
